import React, { createContext, useContext } from 'react';
import { SegmentTrackerInterface } from './SegmentTracker';

const SegmentTrackingContext = createContext<SegmentTrackerInterface | null>(null);

export const SegmentTrackingProvider: React.FC<{ tracker: SegmentTrackerInterface }> = ({ tracker, children }) => {
    return <SegmentTrackingContext.Provider value={tracker}>{children}</SegmentTrackingContext.Provider>;
};

export const useSegmentTracking = () => {
    const tracker = useContext(SegmentTrackingContext);
    if (tracker == null) {
        return {
            track: () => null,
            identify: () => null,
            page: () => null,
            reset: () => null,
        };
    }

    return {
        track: (eventName: string, props?: Object) => {
            tracker.track(eventName, props);
        },
        identify: (id: string, props?: Object) => {
            tracker.identify(id, props);
        },
        page: (name?: string | object, category?: string | object, properties?: object | null) => {
            tracker.page(category, name, properties);
        },
        reset: () => {
            tracker.reset();
        },
    };
};
